import { render, staticRenderFns } from "./RequestsHeader.vue?vue&type=template&id=352e1104&"
import script from "./RequestsHeader.vue?vue&type=script&lang=js&"
export * from "./RequestsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports